import { assets } from '#app/data/assets'

export function Logo() {
	return (
		<div className="flex shrink-0 items-center text-2xl font-medium">
			<div className="flex  items-center justify-center rounded-full text-xl font-bold text-secondary">
				<img
					alt="Logo"
					className="md:max-w-[250px] max-w-[180px] h-auto object-contain"
					src={assets.logos.main}
				/>
			</div>
		</div>
	)
}
